export const OPERATIONAL_CONTEXT_EVENT = 'solo:operational-context-changed';
function positiveId(value) {
  return /^[1-9][0-9]*$/.test(String(value ?? '')) && Number.isSafeInteger(Number(value)) && Number(value)<=2147483647;
}
export function procurementExpectedUser(user, data) {
  if (!positiveId(user?.id)) throw new Error('Session unavailable.');
  if (user.is_platform_admin !== true) return user;
  if (!data || !Object.hasOwn(data,'context')) throw new Error('Selected unit could not be confirmed.');
  if (data.context === null) return user;
  const context = data.context;
  if (!positiveId(context.company_id) || !positiveId(context.unit_id)) throw new Error('Select a company and unit.');
  // Expected response scope for display only; AuthProvider identity is unchanged.
  return {...user,company_id:Number(context.company_id),unit_id:Number(context.unit_id)};
}
export function notifyOperationalContextChanged() {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(OPERATIONAL_CONTEXT_EVENT));
}
